module.exports = __webpack_public_path__ + "static/img/7.fdbecab.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/brand/7.png
// module id = smxt
// module chunks = 45